import Drawer from '@material-ui/core/Drawer';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PagesMenu from './left-panel/PagesMenu';

const useStyles = makeStyles((theme) => {
  return {
    drawer: {
      width: theme.layout.drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      backgroundColor: theme.palette.primary.main,
      width: theme.layout.drawerWidth,
      paddingTop: theme.layout.topBarHeight, // fake header for sticky header
    },
  };
});

const LeftPanel = (_props) => {
  const classes = useStyles();

  return (
    <Drawer
      className={ classes.drawer }
      variant='permanent'
      classes={ {
        paper: classes.drawerPaper,
      } }
    >
      <div>
        <PagesMenu />
      </div>
    </Drawer>
  );
};

export default LeftPanel;
